const moment = require("moment");
window.moment = require('moment');
define(['angular', 'lodash', 'moment'], function(angular, _, moment) {

    function WalletCtrl(
        $scope,
        $rootScope,
        $uibModal,
        $log,
        $location,
        $window,
        $filter,
        walletService,
        Notification,
        userService,
        authService,
        storeService,
        walletFiltersService,
        commonService,
        orderTypeService,
        scenarioTypeService,
        editionService,
        orderFormService,
        orderService,
        marketService,
        contractTypeService,
        storeTypeService
    ) {
        authService.updateLoginStatus(); // on verifie que le token est toujours là
        // $scope.selectActiveMenu(6);
        let self = this;
        self.wallet = [];
        self.initiateur = [];
        self.loadingWallet = true;
        // Is other businesses to load ?
        self.isOtherBusiness = true;
        self.isOtherBusinessLoading = false;

        self.commonService = commonService;
        self.orderTypeService = orderTypeService;
        self.scenarioTypeService = scenarioTypeService;
        self.marketService = marketService;
        self.contractTypeService = contractTypeService;
        self.storeTypeService = storeTypeService;
        self.showSidebar = false;

        /**
         * Update business list
         * @param {Boolean} append
         */
        function _updateBusinessList(append) {
            self.loadingBusiness = true;
            walletService.getAllBusinesses(_filters)
                .then(function(res) {
                    res.map(bus => {
                        bus.department = bus.addressPostalCode.slice(0, 2);
                    });
                    if (append) {
                        self.wallet = self.wallet.concat(res);

                        if (res.length < _filters.limit) {
                            self.isOtherBusiness = false;
                        }
                    }
                    else {
                        self.wallet = res;
                    }
                    self.savedWallet = angular.copy(self.wallet);
                })
                .catch(function(err) {
                    $log.error(err);
                    self.wallet = [];
                })
                .finally(function() {
                    self.isOtherBusinessLoading = false;
                    self.loadingBusiness = false;
                });
        }

        /**
         * Load more businesses
         */
        self.loadMoreBusiness = function () {
            self.isOtherBusinessLoading = true;
            _filters.offset++;
            _updateBusinessList(true);
        };

        self.formatDate = (data, type) => {
            const format = {
                full : data !== null ? moment(data).format('YYYY-MM-DD') : null,
                month : data !== null ? moment(data).format('YYYY-MM') : null,
            }
            return format[type];
        }

        self.formatName = (data) => {
            const user = userService.findPerson(data);
            return user ? user.user.displayName : data;
        }

        self.formatLink = (data) => {
            return data ? '<a href ="#!/prospection/store/' + data + '">' + data + '</a>' : '';
        }

        self.prepareUpdate = function(id) {
            self.businessToUpdate = id;
            _openModalUpdateBusiness('lg');
        };

        function _openModalUpdateBusiness(size) {
            let _updateBusinessModal = $uibModal.open({
                animation: true,
                templateUrl: 'updateBusiness.html',
                controller: 'UpdateBusinessCtrl',
                controllerAs: 'updateBusinessCtrl',
                size: size,
                resolve: {
                    business: function() {
                        return self.wallet.filter(business => business.businessId === self.businessToUpdate);
                    },
                    scenarioType: function() {
                        return self.types;
                    },
                    orderType: function() {
                        return self.networks;
                    },
                    storeActivity: function() {
                        return self.activities;
                    },
                    status: function() {
                        return self.statusList;
                    },
                    users: function() {
                        return self.users;
                    },
                    store: function() {
                        let business = self.wallet.filter(business => business.businessId === self.businessToUpdate);
                        return business[0].storeId ? storeService.getById(business[0].storeId) : [];
                    }
                }
            });
            _updateBusinessModal.result.then(function(data) {
                if( data.delete){
                    _delete(data.business)
                }else{
                    _confirmUpdate(data);
                }
            });
        }

        function _confirmUpdate(data) {
            let business = data.business;
            let store = data.store;
            self.loadingWallet = true;
            try {
                for (let i = 0; i < self.wallet.length; i++) {
                    if (self.wallet[i].businessId === self.businessToUpdate) {
                        if (!self.isValidDateFinContrat(store)) {
                            throw new Error('La date de fin de contrat ne peut pas être avant le 1 janvier 2000.');
                        }
                        walletService
                            .updateBusiness(business)
                            .then(function (resp) {
                                resp.department = resp.addressPostalCode.slice(0, 2);
                                self.wallet[i] = resp;
                            })
                            .then(function () {
                                if (Object.keys(store.fieldsToWatch).length) {
                                    let isFieldToWatchModified;
                                    Object.keys(store.fieldsToWatch).forEach(field => {
                                        isFieldToWatchModified =
                                            store.fieldsToWatch[field].old !== store.fieldsToWatch[field].new &&
                                            store.fieldsToWatch[field].new !== null;
                                    });
                                    if (isFieldToWatchModified && store.etat_magasin === 3) {
                                        return storeService.updateQualifications(store)
                                            .then(function () {
                                                // location.reload();
                                            });
                                    }
                                }
                                Notification.success('Affaire mise à jour.');
                            })
                            .catch(function (err) {
                                Notification.error('Une erreur est survenue: ' + err.data);
                                $log.error(err);
                            }).finally(function () {
                            self.loadingWallet = false;
                            // location.reload();
                        });
                        break;
                    }
                }
            }
            catch(err){
                Notification.error('Une erreur est survenue: ' + err.data);
                self.loadingWallet = false;
            }
        }

        function _delete(business) {
            for (let i = 0; i < self.wallet.length; i++) {
                if (self.wallet[i].businessId === self.businessToUpdate) {
                    self.wallet[i] = business;
                    walletService
                        .deleteBusiness(self.wallet[i])
                        .then(function() {
                            return walletService
                                .getAllBusinesses(_filters)
                                .then(res => {
                                    res.map(bus => {
                                        bus.department = bus.addressPostalCode.slice(0, 2);
                                    });
                                    self.wallet = res;
                                    self.table.clear().draw();
                                    self.table.rows.add(self.wallet).draw();
                                    Notification.success('Affaire supprimée.');
                            });
                        })
                        .catch(function(err) {
                            Notification.error('Une erreur est survenue: ' + err.data);
                            $log.error(err);
                        }).finally(function(){
                            self.loadingWallet = false;
                    });
                    break;
                }
            }
        }

        function _getUser() {
            return userService.getUsers().then(res => {
                self.users = res;
                return res;
            }).catch(err => {
                // Notify the user of an error.
                Notification.error('Une erreur est survenue : ' + err.data);
            });
        }

        /**
         * Retrieve the business form (scenario type, order type, store activity, status) from the API.
         * @return {Promise} A promise that resolves with the business form data.
         */
        function _getBusinessForm() {
            return walletService
                .getBusinessForm()
                .then(data => {
                    // Save the business form data.
                    self.types = data.scenarioTypes;
                    self.networks = data.orderTypes;
                    self.activities = data.storeActivities;
                    self.status = data.status;
                    return data;
                })
                .catch(err => {
                    // Notify the user of an error.
                    Notification.error('Une erreur est survenue : ' + err.data);
                });
        }

        /**
         * Generate the values for the rds filter at the clear or loading action
         * @return {Array}
         */
        function _generateRDSFilter() {
            if (self.userNetwork.user.role === 'DRV') {
                _filters.drv = [self.userNetwork.user.uid];
            }
            if (!self.userNetwork.drv.length && self.userNetwork.rds.length) {
                let rds = [];
                for (let i = 0; i < self.userNetwork.rds.length; i++) {
                    rds.push(self.userNetwork.rds[i].user.uid);
                }
                _filters.rds = rds;
                // _filters.users = rds;
            }

            if (self.userNetwork.user.role === 'RDS' || userService.isExternalUser(self.userNetwork.user)) {
                // let users = [];
                if (self.userNetwork.user.role === 'RDS') {
                    // if(self.userNetwork.cs.length){
                    //     users.push(self.userNetwork.cs[0].user.uid);
                    // }
                    // if(self.userNetwork.telepro.length) {
                    //     users.push(self.userNetwork.telepro[0].user.uid);
                    // }
                    // _filters.rds = [self.userNetwork.user.uid];
                }
                // users.push(self.userNetwork.user.uid);
                // _filters.users = users;
            }

            if (self.userNetwork.user.role === 'CS' || self.userNetwork.user.role === 'TELEPRO') {
                let rds = [];
                for (let i = 0; i < self.userNetwork.rdsBusiness.length; i++) {
                    rds.push(self.userNetwork.rdsBusiness[i].user.uid);
                }
                _filters.rds = rds;
                // _filters.initiateur = [self.userNetwork.user.uid];
            }
        }

        self.isValidDateFinContrat = (store) => {
            return !moment(store.qualification.fin_contrat).isBefore(moment([2000, 0, 1]));

        }

        /* =========================================================================================== */
        /*                                        FILTERS                                              */
        /* =========================================================================================== */

        let _filters = {
            rds: [],
            drv: [],
            // telepro: [],
            // cs: [],
            // cup: [],
            initiateur: [],
            formerRDS: [],
            users: [],
            offset: 0,
            limit: 50
        };

        _initIHMFilters();

        self.isFiltered = false;

        /* Date updated filter */
        self.dateStartFilterOptions = walletFiltersService.dateUpdatedOptions;
        self.dateEndFilterOptions = walletFiltersService.dateUpdatedOptions;

        self.isOpenedDateStartFilter = false;
        self.isOpenedDateEndFilter = false;
        self.isOpenedCreationDateStartFilter = false;
        self.isOpenedCreationDateEndFilter = false;

        self.toggleDateStartFilter = function () {
            self.isOpenedDateStartFilter = walletFiltersService.toggle(self.isOpenedDateStartFilter);
        };

        self.toggleDateEndFilter = function () {
            self.isOpenedDateEndFilter = walletFiltersService.toggle(self.isOpenedDateEndFilter);
        };

        self.toggleCreationDateStartFilter = function () {
            self.isOpenedCreationDateStartFilter = walletFiltersService.toggle(self.isOpenedCreationDateStartFilter);
        };

        self.toggleCreationDateEndFilter = function () {
            self.isOpenedCreationDateEndFilter = walletFiltersService.toggle(self.isOpenedCreationDateEndFilter);
        };

        /* Month of signature filter */
        self.signatureMonthFilterOptions = walletFiltersService.signatureMonthOptions;
        self.isOpenedSignatureMonthFilter = [false, false];

        self.toggleSignatureMonthFilter = function (index) {
            self.isOpenedSignatureMonthFilter[index] = walletFiltersService.toggle(self.isOpenedSignatureMonthFilter[index]);
        };

        /* Month of relance filter */
        self.relanceMonthFilterOptions = walletFiltersService.relanceMonthOptions;
        self.isOpenedRelanceMonthFilter = [false, false];

        self.toggleRelanceMonthFilter = function (index) {
            self.isOpenedRelanceMonthFilter[index] = walletFiltersService.toggle(
                self.isOpenedRelanceMonthFilter[index]
            );
        };

        /**
         * Apply selected filter values
         */
        self.applyFilter = function () {
            if (!self.isFiltered) {
                _filters.offset = 0;
                self.isOtherBusiness = true;
                self.showSidebar = false;
            }

            if (
                self.identifiantFilter !== null &&
                self.identifiantFilter !== '' &&
                !Number.isInteger(parseInt(self.identifiantFilter))
            ) {
                Notification.error("<b>Erreur sur l'identifiant:</b> ce n'est pas un nombre");
                return;
            }
            if (
                self.departmentFilter !== null &&
                self.departmentFilter !== '' &&
                !Number.isInteger(parseInt(self.departmentFilter))
            ) {
                Notification.error("<b>Erreur sur le département : </b> ce n'est pas un nombre");
                return;
            }
            if (
                self.dateEndFilter !== null &&
                commonService.checkDateRange(self.dateStartFilter, self.dateEndFilter) === false
            ) {
                Notification.error(
                    '<b>Erreur sur la période du filtre:</b> date de modification de début avant celle de fin'
                );
                return;
            }
            if (
                self.creationDateEndFilter !== null &&
                commonService.checkDateRange(self.creationDateStartFilter, self.creationDateEndFilter) === false
            ) {
                Notification.error(
                    '<b>Erreur sur la période du filtre:</b> date de création de début avant celle de fin'
                );
                return;
            }
            if (
                self.signatureMonthFilter[1] !== null &&
                commonService.checkDateRange(self.signatureMonthFilter[0], self.signatureMonthFilter[1]) === false
            ) {
                Notification.error(
                    '<b>Erreur sur la période du filtre:</b> Mois de signature de début avant celui de fin'
                );
                return;
            }
            if (
                self.relanceMonthFilter[1] !== null &&
                commonService.checkDateRange(self.relanceMonthFilter[0], self.relanceMonthFilter[1]) === false
            ) {
                Notification.error(
                    "<b>Erreur sur la période du filtre:</b> Mois de relance  de début avant celui de fin"
                );
                return;
            }

            // Map present filters in the controller to build an array with their values
            var filtersToSave = walletFiltersService.filtersList.map(function(key) {
                return self[key];
            });
            // Save builts array with filters values
            walletFiltersService.saveFilters(filtersToSave);

            _filters.dateStart = walletFiltersService.applyFullDateFilter(self.dateStartFilter);
            _filters.dateEnd = walletFiltersService.applyFullDateFilter(self.dateEndFilter);
            _filters.creationDateStart = walletFiltersService.applyFullDateFilter(self.creationDateStartFilter);
            _filters.creationDateEnd = walletFiltersService.applyFullDateFilter(self.creationDateEndFilter);
            _filters.signatureMonth = self.signatureMonthFilter.map(walletFiltersService.applyMonthDateFilter);
            _filters.relanceMonth = self.relanceMonthFilter.map(walletFiltersService.applyMonthDateFilter);

            _updateBusinessList();

        };

        /**
         * Watch drv filter input to construct filter value
         */
        self.updateDRVFilter = function updateDRVFilter() {
            var selectedDRV = $filter('filter')(self.userNetwork.drv, { checked: true });
            _filters.drv = [];
            var parents = [];

            for (var i = 0; i < selectedDRV.length; i++) {
                _filters.drv.push(selectedDRV[i].user.uid);
                parents.push(selectedDRV[i]);
            }

            self.rdsFilter = _generateRDSFilterForIHM(parents);
        };

        /**
         * Watch rds filter input to construct filter value
         */
        self.updateRDSFilter = function updateRDSFilter() {
            var selectedRDS = $filter('filter')(self.userNetwork.rds, { checked: true });
            _filters.rds = [];

            for (var i = 0; i < selectedRDS.length; i++) {
                _filters.rds.push(selectedRDS[i].user.uid);
            }
        };

        self.updateInitiateurFilter = function () {
            var selectedInitiateur = $filter('filter')(self.userNetwork.gestionnaires, { checked: true });
            _filters.initiateur = [];

            for (var i = 0; i < selectedInitiateur.length; i++) {
                _filters.initiateur.push(selectedInitiateur[i].user.uid);
            }
        };


        self.updateFormerRDSFilter = function updateFormerRDSFilter() {
            var selectedRDS = $filter('filter')(self.userNetwork.formerRDS, { checked: true });
            _filters.formerRDS = [];

            for (var i = 0; i < selectedRDS.length; i++) {
                _filters.formerRDS.push(selectedRDS[i].user.uid);
            }
        };

        /**
         * Reset filters
         */
        self.clearFilters = function (isDefault) {
            isDefault = isDefault || false;
            walletFiltersService.clearFilters();

            _initIHMFilters();

            _filters.rds = [];
            _filters.drv = [];
            // _filters.telepro = [];
            // _filters.cs = [];
            // _filters.cup = [];
            _filters.initiateur = [];
            _filters.formerRDS = [];
            _filters.activity = [];
            _filters.status = [];
            _filters.offset = 0;

            _initFiltersValues();

            var activityFilterLength = self.activityFilter.length;
            for (var i = 0; i < activityFilterLength; i++) {
                self.activityFilter[i] = false;
            }

            if (!isDefault) {
                var statusFilterLength = self.statusFilter.length;
                for (var i = 0; i < statusFilterLength; i++) {
                    self.statusFilter[i] = false;
                }
            }else {
                self.statusFilter = [true, true, true, true, false, false, false, false]; // by default "En cours" status is checked
            }

            _updateStatusFilter();

            self.userNetwork.rds.forEach(function(rds) {
                rds.checked = false;
            });

            self.userNetwork.drv.forEach(function(drv) {
                drv.checked = false;
            });

            // self.userNetwork.telepro.forEach(function(telepro) {
            //     telepro.checked = false;
            // });

            // self.userNetwork.cs.forEach(function(cs) {
            //     cs.checked = false;
            // });

            self.userNetwork.gestionnaires.forEach(function(gest) {
                gest.checked = false;
            });

            // self.userNetwork.cup.forEach(function(cup) {
            //     cup.checked = false;
            // });

            self.userNetwork.formerRDS.forEach(function(formerRDS) {
                formerRDS.checked = false;
            });

            self.rdsFilter = _generateRDSFilterForIHM();
            _updateBusinessList()
        };

        $scope.$watchCollection('walletCtrl.networkFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.network = walletFiltersService.applyFilter(self.networkFilter, 'network');

            if (!oldValue[0] && newValue[0]) {
                self.networkFilter = [true, false, false];
            }

            if (!oldValue[1] && newValue[1]) {
                self.networkFilter = [false, true, false];
            }

            if (!oldValue[2] && newValue[2]) {
                self.networkFilter = [false, false, true];
            }
        });

        $scope.$watchCollection('walletCtrl.businessScenarioFilter', function(newValue, oldValue) {
            if (oldValue.length === 0) {
                return;
            }
            _filters.businessScenario = walletFiltersService.applyMultipleFilterValues(
                self.businessScenarioFilter,
                'businessScenario'
            );

            if (!oldValue[0] && !oldValue[1] && !oldValue[2] && (newValue[0] || newValue[1] || newValue[2])) {
                newValue[3] = false;
            }

            if (!oldValue[3] && newValue[3]) {
                newValue[0] = false;
                newValue[1] = false;
                newValue[2] = false;
            }
            self.businessScenarioFilter = newValue;
        });

        $scope.$watch('walletCtrl.clientFilter', function(newValue, oldValue) {
            if (oldValue === '') {
                return;
            }
            _filters.client = null;

            if (newValue !== '') {
                _filters.client = newValue;
            }
        });

        $scope.$watch('walletCtrl.identifiantFilter', function(newValue, oldValue) {
            if (oldValue === '') {
                return;
            }
            _filters.identifiant = null;

            if (newValue !== '') {
                _filters.identifiant = newValue;
            }
        });

        $scope.$watch('walletCtrl.departmentFilter', function(newValue, oldValue) {
            if (oldValue === '') {
                return;
            }
            _filters.department = null;

            if (newValue !== '') {
                _filters.department = newValue;
            }
        });

        /**
         *  update filters.activity with id from activitiesList according to checked filters
         */
        function _updateActivityFilter() {
            var activityCodes = self.activitiesList.map(function(activity) {
                // get code
                return activity.code;
            });
            _filters.activity = walletFiltersService.applyMultipleFilterValues(self.activityFilter, activityCodes);
        }
        self.updateActivityFilter = _updateActivityFilter;

        function _updateStatusFilter() {
            let statusIds = self.statusList.map(function(status) {
                // get id
                return status.id;
            });
            _filters.status = walletFiltersService.applyMultipleFilterValues(self.statusFilter, statusIds);
        }
        self.updateStatusFilter = _updateStatusFilter;


        /**
         * Generate the RDS filter options list
         * @param  {Array} parents
         * @return {Array}
         */
        function _generateRDSFilterForIHM(parents) {
            if (!parents || !parents.length) {
                return self.userNetwork.rds.length ? self.userNetwork.rds : self.userNetwork.rdsBusiness;
            }

            var rds = [];
            for (var i = 0; i < parents.length; i++) {
                for (var j = 0; j < self.userNetwork.rds.length; j++) {
                    if (parents[i].user.uid === self.userNetwork.rds[j].parent) {
                        rds.push(self.userNetwork.rds[j]);
                    }
                }
            }
            console.log(rds);
            return rds;
        }

        function _generateStatusFilterForIHM(status) {
            return walletFiltersService.getDefaultFilter('boolean', status.length);
        }

        function _generateActivityFilterForIHM(activities) {
            return walletFiltersService.getDefaultFilter('boolean', activities.length);
        }

        function _generateNetworkFilterForIHM(orderTypes) {
            return walletFiltersService.getDefaultFilter('boolean', orderTypes.length);
        }

        function _generateScenarioFilterForIHM(scenarioTypes) {
            return walletFiltersService.getDefaultFilter('boolean', scenarioTypes.length);
        }


        /**
         * Apply default filters Values to IHM
         */
        function _initIHMFilters() {
            if (walletFiltersService.saved) {
                walletFiltersService.filtersList.forEach(function(key, index) {
                    self[key] = walletFiltersService.getFilters()[index]; // assign saved filter values
                });
            }
            else {
                self.networkFilter = walletFiltersService.getDefaultFilter('boolean', 3);
                self.businessScenarioFilter = walletFiltersService.getDefaultFilter('boolean', 4);
                self.identifiantFilter = walletFiltersService.getDefaultFilter('integer');
                self.clientFilter = walletFiltersService.getDefaultFilter('string');
                self.dateStartFilter = walletFiltersService.getDefaultFilter('date');
                self.dateEndFilter = walletFiltersService.getDefaultFilter('date');
                self.creationDateStartFilter = walletFiltersService.getDefaultFilter('date');
                self.creationDateEndFilter = walletFiltersService.getDefaultFilter('date');
                self.signatureMonthFilter = walletFiltersService.getDefaultFilter('dateInterval', 2);
                self.relanceMonthFilter = walletFiltersService.getDefaultFilter('dateInterval', 2);
                self.departmentFilter = walletFiltersService.getDefaultFilter('integer');
                self.statusFilter = [true, true, true, true, false, false, false, false]; // by default "En cours" status is checked
            }
        }

        function _initFiltersValues() {
            _filters.identifiant = self.identifiantFilter;
            _filters.network = walletFiltersService.applyFilter(self.networkFilter, 'network');
            _filters.dateStart = walletFiltersService.applyFullDateFilter(self.dateStartFilter);
            _filters.dateEnd = walletFiltersService.applyFullDateFilter(self.dateEndFilter);
            _filters.creationDateStart = walletFiltersService.applyFullDateFilter(self.creationDateStartFilter);
            _filters.creationDateEnd = walletFiltersService.applyFullDateFilter(self.creationDateEndFilter);
            _filters.signatureMonth = self.signatureMonthFilter.map(walletFiltersService.applyMonthDateFilter);
            _filters.relanceMonth = self.relanceMonthFilter.map(walletFiltersService.applyMonthDateFilter);
            _filters.client = self.clientFilter;
            _filters.businessScenario = walletFiltersService.applyMultipleFilterValues(self.businessScenarioFilter, 'businessScenario');
            _filters.department = self.departmentFilter;
        }

        self.print = function() {
            let json = {'lignes': self.wallet}
            editionService.printBusiness(json).then(function(data) {
                _printPreview(data);
            });
        }

        let _printPreview = (data, type = 'application/pdf') => {
            try {
                if (!data) {
                    throw new Error('Données invalides');
                }

                // Supprime l'ancien embed s'il existe
                let oldIframe = $window.document.querySelector('#pdfViewer');
                if (oldIframe) {
                    oldIframe.remove();
                }

                const blob = commonService.b64toBlob(data, type);
                const blobURL = URL.createObjectURL(blob);

                // Création de l'élément embed
                const iframeElement = $window.document.createElement('iframe');
                iframeElement.id = 'pdfViewer';
                iframeElement.src = blobURL;
                iframeElement.type = type;
                iframeElement.style.width = '800px';
                iframeElement.style.height = '600px';

                // Ajout de l'élément au document
                $window.document.body.appendChild(iframeElement);
                iframeElement.style.display = 'none';
                // Attendre que le PDF soit chargé avant d'imprimer
                iframeElement.onload = () => {
                    // Nettoyage de l'URL
                    URL.revokeObjectURL(blobURL);

                    // Impression automatique
                    setTimeout(function() {
                        // iframeElement.focus();
                        iframeElement.contentWindow.print();
                    }, 1);
                };
                // on laisse 10s pour cliquer sur le bouton imprimer après on supprime l'iframe
                setTimeout(function() {
                    iframeElement.remove();
                }, 60000);
            } catch (error) {
                console.error('Erreur lors de la prévisualisation:', error);
                throw error;
            }
        };

        self.goToOrderList = (id) => {
            orderService.getOrders({businessId: id, rds: [], drv: [], telepro: [], cs: [], cup: [], formerRDS: [], offset: 0, limit:50}).then(function(data) {
                $rootScope.orders = data;
                $rootScope.business = id;
                $location.path('/bdc/list/');
            });

        }

        self.applyQuickSearchFilter = () => {
            self.wallet  = angular.copy(self.savedWallet);
            if (self.quickSearchFilter && self.quickSearchFilter.length >= 3) {
                self.wallet = self.wallet.filter(function(item) {
                    return (item.storeId && item.storeId.toString().includes(self.quickSearchFilter)) ||
                        (item.lastName && item.lastName.toLowerCase().includes(self.quickSearchFilter.toLowerCase()) ||
                        item['NIM'] && item['NIM'].toLowerCase().includes(self.quickSearchFilter.toLowerCase()));
                });
            }
        }

        /* =========================================================================================== */
        /*                                         MODAL                                                */
        /* =========================================================================================== */


        /**
         * Open the order creation modal : first step
         * @param  {String} size
         */
        self.openModalFirstStep = function(size) {
            var _firstStepModal = $uibModal.open({
                animation: true,
                templateUrl: 'firstStepModal.html',
                controller: 'CreateBDCFirstStepCtrl',
                controllerAs: 'createBDCFirstStepCtrl',
                size: size,
                resolve: {}
            });

            _firstStepModal.result.then(function(res) {
                $rootScope.order.orderType = res.orderType;
                $rootScope.order.marketType = res.orderMarket;

                // Mudetaf is never used for FLEURISTE
                if (res.orderMarket === 'FLEURISTE') {
                    $rootScope.order.contract.isMudetaf = false;
                }

                if (!res.client) {
                    return self.openModalSecondStep();
                }

                $rootScope.order.client = res.client;
                self.openModalSecondStep();
            });
        };

        /**
         * Open the order creation modal : second step
         * @param  {String} size
         */
        self.openModalSecondStep = function(size) {
            var _secondStepModal = $uibModal.open({
                animation: true,
                templateUrl: 'createUpdateClient.html', // modal client.html
                controller: 'CreateUpdateClientCtrl',
                controllerAs: 'createUpdateClientCtrl',
                size: size,
                resolve: {
                    order: function() {
                        return $rootScope.order;
                    }
                }
            });

            _secondStepModal.result.then(function(data) {
                console.log(data);
                if(data.client.business){
                    if(moment(data.client.business.dateCreation).isAfter(moment().subtract(12,'month'))
                        && data.client.business.businessStatusId === 3){
                        self.openModalLastBusiness('lg');
                        return;
                    }
                }
                _goToOrderForm();
            });
        };

        self.openModalLastBusiness = (size) => {
            var _lastBusinessModal = $uibModal.open({
                animation: true,
                templateUrl: 'lastBusinessModal.html',
                controller: 'LastBusinessCtrl',
                controllerAs: 'lastBusinessCtrl',
                size: size,
                resolve: {
                    order: function() {
                        return $rootScope.order;
                    }
                }
            });

            _lastBusinessModal.result.then(function(resp) {
                if (resp)
                    self.goToOrderList($rootScope.order.client.business.businessId);
                $scope.goTo('/bdc/order');
            })
        }
        /**
         * Go to the order form
         */
        function _goToOrderForm() {
            $scope.goTo('/bdc/order');
        }


        /* =========================================================================================== */
        /*                                         INIT                                                */
        /* =========================================================================================== */
        /**
         * Init the business list
         * 1) Get the user network
         * 2) Init the filters
         * 3) Get the businesses
         */
        function _init() {
            self.userNetwork = $rootScope.userNetwork;
            self.user = $rootScope.user;
            self.isExt = userService.isExternalUser(self.userNetwork.user);
            self.rdsFilter = _generateRDSFilterForIHM();
            // if (self.userNetwork.rds && self.userNetwork.rds.length) {
            //     self.rdsFilter = self.userNetwork.rds;
            // }
            // if (self.userNetwork.telepro && self.userNetwork.telepro.length) {
            //     self.teleproFilter = self.userNetwork.telepro;
            // }
            // if (self.userNetwork.cs && self.userNetwork.cs.length) {
            //     self.csFilter = self.userNetwork.cs;
            // }
            if (self.userNetwork.gestionnaires && self.userNetwork.gestionnaires.length) {
                self.initiateurFilter = self.userNetwork.gestionnaires;
            }
            if (self.userNetwork.drv && self.userNetwork.drv.length) {
                self.drvFilter = self.userNetwork.drv;
            }
            // if (self.userNetwork.cup && self.userNetwork.cup.length) {
            //     self.cupFilter = self.userNetwork.cup;
            // }
            if (self.userNetwork.formerRDS && self.userNetwork.formerRDS.length) {
                self.formerRDSFilter = self.userNetwork.formerRDS;
            }
            _getUser();
            _generateRDSFilter();
            _getBusinessForm().then((form)=>{
                _initServicesData(form);
                _initFiltersValues();
                self.activitiesList = self.activities;
                self.activityFilter = _generateActivityFilterForIHM(self.activitiesList);
                _updateActivityFilter();
                self.statusList = _orderStatus(self.status);
                self.statusFilter = _generateStatusFilterForIHM(self.statusList);
                self.statusFilter = [true, true, true, true, false, false, false, false]; // by default "En cours" status is checked
                _updateStatusFilter();

                self.networkList = form.orderTypes;
                self.networkFilter = _generateNetworkFilterForIHM(self.networkList);
                self.scenarioTypeList = form.scenarioTypes
                self.businessScenarioFilter = _generateScenarioFilterForIHM(self.scenarioTypeList);
            }).then(()=>{
                self.loadingWallet = true;
                return walletService.getAllBusinesses(_filters).then(res => {
                    res.map(bus => {
                        bus.department = bus.addressPostalCode.slice(0, 2);
                        bus.RDS = self.formatName(bus.RDS)
                    });
                    self.wallet = res;
                    self.savedWallet = angular.copy(self.wallet);
                })
            }).then(() => {
                $rootScope.order = orderService.getOrderObject();
                // Init order to create
                $rootScope.order.RDSRef = self.userNetwork.user.uid;
                $rootScope.order.DRVRef = self.userNetwork.user.parent
                    ? self.userNetwork.user.parent.uid
                    : self.userNetwork.user.parent;
                if (!$rootScope.orderForm){
                    return orderFormService
                        .getOrderForm()
                        .then(function(orderForm) {
                            $rootScope.orderForm = orderForm;
                            self.offerTypeList = orderForm.offers;

                            _initOrderServicesData(orderForm);
                        });
                }
            })
            .catch(function(err) {
                $log.error(err);
                self.userNetwork = null;
                self.wallet = [];
            })
            .finally(function() {
                self.loadingWallet = false;
            });
        }

        function _initServicesData(form) {
            self.orderTypeService.initOrderTypes(form);
            self.scenarioTypeService.initScenarioTypes(form);
            walletFiltersService.initFiltersValues();
        }

        function _initOrderServicesData(orderForm) {
            self.marketService.initMarkets(orderForm);
            self.contractTypeService.initContractTypes(orderForm);
            self.storeTypeService.initStoreTypes(orderForm);
        }

        function _orderStatus(status){
            let array = [];
            status.forEach(stat => {
                if(stat.businessStatusLabel === 'En cours')
                    array[0] = stat;
                if(stat.businessStatusLabel === 'À relancer')
                    array[1] = stat;
                if(stat.businessStatusLabel === 'RDV Pris')
                    array[2] = stat;
                if(stat.businessStatusLabel === 'Démo faite')
                    array[3] = stat;
                if(stat.businessStatusLabel === 'Gagnée')
                    array[4]= stat;
                if(stat.businessStatusLabel === 'Perdue')
                    array[5] = stat;
                if(stat.businessStatusLabel === 'Hors cible')
                    array[6] = stat;
                if(stat.businessStatusLabel === 'Pas interressé')
                    array[7] = stat;
            });
            return array;
        }

        _init();

        return self;
    }

    WalletCtrl.$inject = [
        '$scope',
        '$rootScope',
        '$uibModal',
        '$log',
        '$location',
        '$window',
        '$filter',
        'walletService',
        'Notification',
        'userService',
        'authService',
        'storeService',
        'walletFiltersService',
        'commonService',
        'orderTypeService',
        'scenarioTypeService',
        'editionService',
        'orderFormService',
        'orderService',
        'marketService',
        'contractTypeService',
        'storeTypeService'
    ];

    angular
        .module('app.prospection.wallet.walletCtrl', ['ui.bootstrap.modal', 'ui-notification'])
        .controller('WalletCtrl', WalletCtrl);
});
